/** One starred-list row (Home panel and full page). `to` is precomputed by the parent; null = not openable. */
import React from 'react';
import type { SavedStarredList } from '../../types';
import { ShellNavLink } from './ShellNavLink';

interface Props {
  list: SavedStarredList;
  to: string | null;
  replace?: boolean | undefined;
  onBeforeNavigate?: (() => void) | undefined;
  trailing?: React.ReactNode;
  meta?: React.ReactNode;
}

export const SavedListRow: React.FC<Props> = ({ list, to, replace, onBeforeNavigate, trailing, meta }) => {
  const body = (
    <>
      <span className={`min-w-0 flex-1 truncate text-[14px] ${to === null ? 'text-ink-3' : 'text-ink'}`}>{list.name}</span>
      <span className="shrink-0 text-[12px] text-ink-3">
        {list.drugs.length} drugs
        {meta != null && <> · {meta}</>}
      </span>
    </>
  );
  return (
    <div className="flex items-center gap-2 border-b border-line-subtle" data-testid={`starred-row-${list.id}`}>
      {to === null ? (
        <div aria-disabled="true" className="flex min-w-0 flex-1 items-center justify-between gap-3 py-3">{body}</div>
      ) : (
        <ShellNavLink
          to={to}
          replace={replace}
          onBeforeNavigate={onBeforeNavigate}
          className="flex min-w-0 flex-1 items-center justify-between gap-3 py-3 text-ink no-underline hover:text-accent"
        >
          {body}
        </ShellNavLink>
      )}
      {trailing != null && <div className="shrink-0">{trailing}</div>}
    </div>
  );
};

export default SavedListRow;
